import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getList } from "actions/scooter/battery-history/actions";

import CommonTable from "views/lib/components/CommonTable";

import Filers from "./filters";

const Scooter = ({
                   list,
                   getList,
                 }) => {
  const getColumns = () => [
    {
      id: "id",
      Header: "ID",
      accessor: "id",
    },
    {
      id: "user",
      Header: "User",
      accessor: "user",
    },
    {
      id: "date",
      Header: "Date",
      accessor: original => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
      Cell: ({ original }) => moment(original.date)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "battery",
      Header: "Battery",
      accessor: "battery",
    },
    {
      id: "from",
      Header: "Status From",
      accessor: "from",
    },
    {
      id: "to",
      Header: "Status To",
      accessor: "to",
    },
    {
      id: "scooter",
      Header: "Scooter",
      accessor: "scooter",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/scooter/scooter/${original.scooter}`}>
          {original.scooterQr}
        </Link>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={Filers}
      searchHookProps={{
        size: 20,
        sort: "date,desc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.scooterBatteryHistory.list,
});

const mapStateToDispatch = dispatch => ({
  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Scooter);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/battery-history/index.js